import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {AddImageComponent} from './editor/add-image/add-image.component';
import {EditorCommonComponent} from './editor/editor.component';
import {PreviewCommonComponent} from './preview/preview.component';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule
    ],
    declarations: [
        AddImageComponent,
        EditorCommonComponent,
        PreviewCommonComponent
    ],
    exports: [
        AddImageComponent,
        EditorCommonComponent,
        PreviewCommonComponent
    ],
    entryComponents:[
        AddImageComponent,
        PreviewCommonComponent
    ],
    providers: [
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})

export class TemplateCommonModule {}



// WEBPACK FOOTER //
// ./src/app/common/template/templateCommon.module.ts